import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { MdAccountCircle } from 'react-icons/md';
import Moment from 'react-moment';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';
import PlainText from '../../../pages-parts/display-info/standard/PlainText';


const StyledSection5 = styled.div`
    position: relative;
    width: 100%;
    transition: all .5s ease-in-out;
    margin-bottom: 0;
    padding: 1rem 1.75rem;
    background-color: ${({ theme }) => theme.colors.background.elements};
    border-radius: 0.75rem;
    position: relative;
    border: 1px solid #ccc;

    
    
    
    .infoData{
        color: ${({ theme }) => theme.colors.text.primary};
    }
    .scroll-thumb{
        background-color: ${({ theme }) => theme.colors.primary_8};
    }
`;

const Section5 = ({ ownerData }) => {

    const [displayData, setDisplayData] = useState([]);

    useEffect(() => {

        setDisplayData([
            {
                title: 'رقم حساب الايبان',
                value: '4548 2348 7956 6549',
                hasNumber: true
            },
            {
                title: 'اسم صاحب الحساب البنكي',
                value: ownerData.ownerOrRepresentative,
                hasNumber: false
            },
            {
                title: 'اسم البنك',
                value: 'بنك فيصل',
                hasNumber: false
            },
            {
                title: 'كود السويفت',
                value: 752,
                hasNumber: true
            },
            {
                title: 'عنوان البنك',
                value: '--',
                hasNumber: false
            },
        ]);
    }, [ownerData]);

    return (
        <StyledSection5>
            <h2 className='sectionFloatTitle'>البيانات الائتمانية</h2>

            <Row className='mt-2'>
                <Col md="6" className='mb-2'>
                    <h4>بطاقة <span className='numbers-font'>(1)</span></h4>
                    {displayData.map((item, i) => (
                        <PlainText
                            key={i}
                            title={item.title}
                            value={item.value}
                            hasNumber={item.hasNumber}
                        />
                    ))}
                </Col>
            </Row>
        </StyledSection5>
    );
}

export default Section5;